import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    meta: { title: "My Requests" },
    component: () =>
      import(/* webpackChunkName: "StudentRequests" */ "@/views/student/StudentRequests.vue"),
  },
  {
    path: "/request-access",
    meta: { title: "Request Access" },
    component: () =>
      import(/* webpackChunkName: "RequestAccess" */ "@/views/student/RequestAccess.vue"),
  },
  {
    path: "/assignments",
    meta: { title: "Approval Requests" },
    component: () =>
      import(/* webpackChunkName: "Assignments" */ "@/views/Assignments.vue"),
  },
  {
    path: "/departments",
    meta: { title: "Department Requests" },
    component: () =>
      import(/* webpackChunkName: "Departments" */ "@/views/Departments.vue"),
  },
  {
    path: "/requests",
    meta: { title: "Request History" },
    component: () =>
      import(/* webpackChunkName: "Requests" */ "@/views/Requests.vue"),
  },
  {
    path: "/configure/deadline-text",
    meta: { title: "Configure Deadline Text" },
    component: () =>
      import(/* webpackChunkName: "ConfigureDeadlineText" */ "@/views/configure/ConfigureDeadlineText.vue"),
  },
  {
    path: "/configure/email-content",
    meta: { title: "Configure Email Content" },
    component: () =>
      import(/* webpackChunkName: "ConfigureEmailContent" */ "@/views/configure/ConfigureEmailContent.vue"),
  },
  {
    path: "/configure/status-types",
    meta: { title: "Configure Status Types" },
    component: () =>
      import(/* webpackChunkName: "ConfigureStatusTypes" */ "@/views/configure/ConfigureStatusTypes.vue"),
  },
  {
    path: "/configure/expirations",
    meta: { title: "Configure Expirations" },
    component: () =>
      import(/* webpackChunkName: "ConfigureExpirations" */ "@/views/configure/ConfigureExpirations.vue"),
  },
  {
    path: "/configure/infotext",
    meta: { title: "Configure Infotext" },
    component: () =>
      import(/* webpackChunkName: "ConfigureInfoText" */ "@/views/configure/ConfigureInfoText.vue"),
  },

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});



export default router;
